import { createFleetApiInstanceWithToken } from '../util';
const maintenance = {
    fetchRMScooterList: (params = {}) => {
        return createFleetApiInstanceWithToken().get('/scooters/maintenance', { params });
    },
};

export default maintenance;
